import '../css/contact.css';

function Contact() {

  return (
    <div className="backGroundCon backGroundSizeCon">
      <div id="Con Title">
        <div className="blankSpaceCon"></div>
        <h1 className="titleCon">Contact</h1>
        <div className="blankSpaceConBottom"></div>
        <div className="blankSpaceCon"></div>
      </div>
      <div className="localCardCon">
        <h2> Hi again! If you are looking to contact me send me a email <a classname="textFont" href='mailto: andrewelder18@gmail.com'>here</a>.</h2>
      </div>
    </div>
  );
}

export default Contact;
